import React, { useCallback, useMemo, useRef, useState } from 'react';
import CustomModal from '../../baseComponents/gui/customModal/CustomModal';
import CustomButton from '../../features/customButton/ui/main/CustomButton';
import classNames from 'classnames';
import { safeHTML } from '../../../utils/safeHTML';
import { useContent } from '../../../redux/reducer/content';
import { useModal } from '../../../hooks/useModal';
import { useTranslation } from '../../../translations';

const WinBeautyBoxModal = React.forwardRef(function WinBeautyBoxModal(
  { image, title, text, promo = false, buttonText, callbacks },
  ref,
) {
  const { state } = useContent();
  const { id, closeModal } = useModal();
  const [copied, setCopied] = useState(false);
  const { t } = useTranslation();

  const handleCopy = () => {
    navigator.clipboard.writeText(promo).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    });
  };

  return (
    <CustomModal>
      <div className={classNames(`win-beauty-box-modal win-beauty-box-modal_${state}`)} ref={ref}>
        <div className={classNames('win-beauty-box-modal__content')}>
          <div className='win-beauty-box-modal__image'>
            <img src={image} alt={t(title)} />
          </div>
          <div className='win-beauty-box-modal__text-container'>
            <h2 className='win-beauty-box-modal__title'>{safeHTML(`${t(title)}`)}</h2>

            {promo && (
              <div className='win-beauty-box-modal__promocode'>
                <div className='win-beauty-box-modal__promocode-text'>{promo}</div>

                <button className='win-beauty-box-modal__promocode-btn' onClick={handleCopy}>
                  {copied ? 'Скопировано!' : 'Скопировать промокод'}
                </button>
              </div>
            )}

            <p className='win-beauty-box-modal__text'>{safeHTML(`${t(text)}`)}</p>
            <CustomButton
              className={'win-beauty-box-modal__button'}
              text={buttonText ?? 'Продолжить'}
              onClick={() => {
                callbacks?.goToNyTask?.();
                closeModal({ id });
              }}
            />
          </div>
        </div>
      </div>
    </CustomModal>
  );
});

export default WinBeautyBoxModal;
WinBeautyBoxModal.propTypes = {};
